import {
  Bundle,
  Product,
  Variation,
} from '@sportngin/se-commerce-sdk/models/clare';

export const isClareCatalogModel = (
  value: unknown,
): value is Product | Bundle => {
  if (!value || typeof value !== 'object') {
    return false;
  }

  return (
    'display_metadata' in value ||
    'default_variation' in value ||
    'price_cents' in value
  );
};

export const pluckClarePrice = (value: Product | Bundle): number => {
  if ('price_cents' in value && value.price_cents !== undefined) {
    return value.price_cents / 100;
  }

  const maybeProduct = value as Product;
  const firstVariation = maybeProduct.variations?.[0];
  if (firstVariation?.price_cents !== undefined) {
    return firstVariation.price_cents / 100;
  }
  if (firstVariation) {
    const variationPrice = (
      firstVariation as Variation & {price?: number | string}
    ).price;
    if (variationPrice !== undefined) {
      return Number(variationPrice);
    }
  }

  if (maybeProduct.default_variation?.price_cents !== undefined) {
    return maybeProduct.default_variation.price_cents / 100;
  }
  if (maybeProduct.default_variation) {
    const variationPrice = (
      maybeProduct.default_variation as Variation & {price?: number | string}
    ).price;
    if (variationPrice !== undefined) {
      return Number(variationPrice);
    }
  }

  if (maybeProduct.variations && maybeProduct.variations.length > 0) {
    const prices = maybeProduct.variations
      .map(v => v.price_cents)
      .filter((p): p is number => p !== undefined && p > 0);
    if (prices.length > 0) {
      return Math.min(...prices) / 100;
    }
  }

  return 0;
};
